// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//import { clientId, domain } from '../auth_config.json';

// Here is the configuration for the testing environment "dupa.test"
// It is similar to "dupa.debug" but with a different API server URL.
// Application source is localhost
// API server is "dupa.disti.pro"
// Database server is "SQL2019CENTOS8.disti.pro"
// Report server is "dupa.disti.pro"
// Authentication server is "dupa.disti.pro"

// It is the -1 step to fully deployed production environment on "dupa.disti.pro".

export const environment = {
  production: true,

  siteConfig: '/assets/app.config.json',
};
